{
	"asset":{
		"generator":"Khronos glTF Blender I/O v4.0.44",
		"version":"2.0"
	},
	"scene":0,
	"scenes":[
		{
			"name":"Scene",
			"nodes":[
				0,
				1,
				2,
				3,
				4,
				5
			]
		}
	],
	"nodes":[
		{
			"mesh":0,
			"name":"Upper Floor",
			"scale":[
				17.846786499023438,
				0.07948042452335358,
				29.88359260559082
			]
		},
		{
			"mesh":1,
			"name":"Basement",
			"scale":[
				20.220300674438477,
				0.3971036970615387,
				31.355932235717773
			],
			"translation":[
				-1.6729339361190796,
				-14.561208724975586,
				0
			]
		},
		{
			"mesh":2,
			"name":"Beam",
			"rotation":[
				0,
				0.3150236904621124,
				0,
				0.9490839242935181
			],
			"scale":[
				1.0690034627914429,
				0.6843739748001099,
				11.957109451293945
			],
			"translation":[
				-4.382561683654785,
				12.831902503967285,
				1.0500515699386597
			]
		},
		{
			"mesh":3,
			"name":"Normal Roof",
			"scale":[
				26.80086326599121,
				24.563934326171875,
				40.96804428100586
			],
			"translation":[
				0,
				33.188350677490234,
				0
			]
		},
		{
			"mesh":4,
			"name":"Arena Roof",
			"rotation":[
				1,
				0,
				0,
				0
			],
			"scale":[
				-32.25532913208008,
				-21.753992080688477,
				-37.05485916137695
			],
			"translation":[
				-63.4922981262207,
				26.525070190429688,
				0
			]
		},
		{
			"mesh":5,
			"name":"Bearl",
			"rotation":[
				-0.9951534867286682,
				0,
				0,
				0.09833399951457977
			],
			"scale":[
				0.2411038875579834,
				0.2411038875579834,
				0.2411038875579834
			],
			"translation":[
				13.249807357788086,
				-5.450758934020996,
				-19.225046157836914
			]
		}
	],
	"materials":[
		{
			"doubleSided":true,
			"name":"Material.023",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.12350903451442719,
					0.11144945025444031,
					0.09248222410678864,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.066",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.2088070809841156,
					0.17625050246715546,
					0.13675370812416077,
					1
				],
				"metallicFactor":0
			}
		},
		{
			"doubleSided":true,
			"name":"Material.002",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.14345639944076538,
					0.0451614186167717,
					0.006090801674872637,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Mushroom top",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.3179771304130554,
					0.007800867781043053,
					0,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Mushroom gills",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.8003705143928528,
					0.5724136233329773,
					0.15717482566833496,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.067",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.10527865588665009,
					0.0952981635928154,
					0.09305760264396667,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.8779527544975281
			}
		}
	],
	"meshes":[
		{
			"name":"Cube.001",
			"primitives":[
				{
					"attributes":{
						"POSITION":0,
						"NORMAL":1,
						"TEXCOORD_0":2
					},
					"indices":3,
					"material":0
				},
				{
					"attributes":{
						"POSITION":4,
						"NORMAL":5,
						"TEXCOORD_0":6
					},
					"indices":7,
					"material":1
				},
				{
					"attributes":{
						"POSITION":8,
						"NORMAL":9,
						"TEXCOORD_0":10
					},
					"indices":11,
					"material":2
				},
				{
					"attributes":{
						"POSITION":12,
						"NORMAL":13,
						"TEXCOORD_0":14
					},
					"indices":15,
					"material":3
				},
				{
					"attributes":{
						"POSITION":16,
						"NORMAL":17,
						"TEXCOORD_0":18
					},
					"indices":19,
					"material":4
				}
			]
		},
		{
			"name":"Cube.002",
			"primitives":[
				{
					"attributes":{
						"POSITION":20,
						"NORMAL":21,
						"TEXCOORD_0":22
					},
					"indices":23,
					"material":0
				},
				{
					"attributes":{
						"POSITION":24,
						"NORMAL":25,
						"TEXCOORD_0":26
					},
					"indices":27,
					"material":5
				}
			]
		},
		{
			"name":"Cube.003",
			"primitives":[
				{
					"attributes":{
						"POSITION":28,
						"NORMAL":29,
						"TEXCOORD_0":30
					},
					"indices":31,
					"material":2
				}
			]
		},
		{
			"name":"Plane",
			"primitives":[
				{
					"attributes":{
						"POSITION":32,
						"NORMAL":33,
						"TEXCOORD_0":34
					},
					"indices":35,
					"material":0
				}
			]
		},
		{
			"name":"Plane.001",
			"primitives":[
				{
					"attributes":{
						"POSITION":36,
						"NORMAL":37,
						"TEXCOORD_0":38
					},
					"indices":39,
					"material":0
				}
			]
		},
		{
			"name":"bear-sp22",
			"primitives":[
				{
					"attributes":{
						"POSITION":40,
						"NORMAL":41,
						"TEXCOORD_0":42
					},
					"indices":43,
					"material":1
				}
			]
		}
	],
	"accessors":[
		{
			"bufferView":0,
			"componentType":5126,
			"count":7386,
			"max":[
				2.2711033821105957,
				424.640625,
				1.3592389822006226
			],
			"min":[
				-5.40962553024292,
				-20.243812561035156,
				-1.4835193157196045
			],
			"type":"VEC3"
		},
		{
			"bufferView":1,
			"componentType":5126,
			"count":7386,
			"type":"VEC3"
		},
		{
			"bufferView":2,
			"componentType":5126,
			"count":7386,
			"type":"VEC2"
		},
		{
			"bufferView":3,
			"componentType":5123,
			"count":18423,
			"type":"SCALAR"
		},
		{
			"bufferView":4,
			"componentType":5126,
			"count":760,
			"max":[
				1.5552979707717896,
				410.933837890625,
				1.056045413017273
			],
			"min":[
				-4.982049465179443,
				-181.55580139160156,
				-1.109564185142517
			],
			"type":"VEC3"
		},
		{
			"bufferView":5,
			"componentType":5126,
			"count":760,
			"type":"VEC3"
		},
		{
			"bufferView":6,
			"componentType":5126,
			"count":760,
			"type":"VEC2"
		},
		{
			"bufferView":7,
			"componentType":5123,
			"count":3201,
			"type":"SCALAR"
		},
		{
			"bufferView":8,
			"componentType":5126,
			"count":78,
			"max":[
				1,
				367.7922668457031,
				0.28684699535369873
			],
			"min":[
				-1.5854427814483643,
				1,
				-0.27788054943084717
			],
			"type":"VEC3"
		},
		{
			"bufferView":9,
			"componentType":5126,
			"count":78,
			"type":"VEC3"
		},
		{
			"bufferView":10,
			"componentType":5126,
			"count":78,
			"type":"VEC2"
		},
		{
			"bufferView":11,
			"componentType":5123,
			"count":120,
			"type":"SCALAR"
		},
		{
			"bufferView":12,
			"componentType":5126,
			"count":240,
			"max":[
				1.0384912490844727,
				-19.386699676513672,
				-0.3330053687095642
			],
			"min":[
				0.5424474477767944,
				-149.9109649658203,
				-0.7650956511497498
			],
			"type":"VEC3"
		},
		{
			"bufferView":13,
			"componentType":5126,
			"count":240,
			"type":"VEC3"
		},
		{
			"bufferView":14,
			"componentType":5126,
			"count":240,
			"type":"VEC2"
		},
		{
			"bufferView":15,
			"componentType":5123,
			"count":360,
			"type":"SCALAR"
		},
		{
			"bufferView":16,
			"componentType":5126,
			"count":458,
			"max":[
				1.0615487098693848,
				-23.27096939086914,
				-0.3330368995666504
			],
			"min":[
				0.5424474477767944,
				-168.20452880859375,
				-0.7650956511497498
			],
			"type":"VEC3"
		},
		{
			"bufferView":17,
			"componentType":5126,
			"count":458,
			"type":"VEC3"
		},
		{
			"bufferView":18,
			"componentType":5126,
			"count":458,
			"type":"VEC2"
		},
		{
			"bufferView":19,
			"componentType":5123,
			"count":684,
			"type":"SCALAR"
		},
		{
			"bufferView":20,
			"componentType":5126,
			"count":1924,
			"max":[
				1.1742371320724487,
				36.76565933227539,
				1.1527562141418457
			],
			"min":[
				-1.1952894926071167,
				-1,
				-1.1068248748779297
			],
			"type":"VEC3"
		},
		{
			"bufferView":21,
			"componentType":5126,
			"count":1924,
			"type":"VEC3"
		},
		{
			"bufferView":22,
			"componentType":5126,
			"count":1924,
			"type":"VEC2"
		},
		{
			"bufferView":23,
			"componentType":5123,
			"count":5310,
			"type":"SCALAR"
		},
		{
			"bufferView":24,
			"componentType":5126,
			"count":201,
			"max":[
				1,
				1,
				1
			],
			"min":[
				-1,
				1,
				-0.875
			],
			"type":"VEC3"
		},
		{
			"bufferView":25,
			"componentType":5126,
			"count":201,
			"type":"VEC3"
		},
		{
			"bufferView":26,
			"componentType":5126,
			"count":201,
			"type":"VEC2"
		},
		{
			"bufferView":27,
			"componentType":5123,
			"count":882,
			"type":"SCALAR"
		},
		{
			"bufferView":28,
			"componentType":5126,
			"count":24,
			"max":[
				1,
				1,
				1
			],
			"min":[
				-1,
				-1,
				-1
			],
			"type":"VEC3"
		},
		{
			"bufferView":29,
			"componentType":5126,
			"count":24,
			"type":"VEC3"
		},
		{
			"bufferView":30,
			"componentType":5126,
			"count":24,
			"type":"VEC2"
		},
		{
			"bufferView":31,
			"componentType":5123,
			"count":36,
			"type":"SCALAR"
		},
		{
			"bufferView":32,
			"componentType":5126,
			"count":164,
			"max":[
				1.3114473819732666,
				0.14077237248420715,
				1
			],
			"min":[
				-1.2022680044174194,
				-0.08340796828269958,
				-1
			],
			"type":"VEC3"
		},
		{
			"bufferView":33,
			"componentType":5126,
			"count":164,
			"type":"VEC3"
		},
		{
			"bufferView":34,
			"componentType":5126,
			"count":164,
			"type":"VEC2"
		},
		{
			"bufferView":35,
			"componentType":5123,
			"count":372,
			"type":"SCALAR"
		},
		{
			"bufferView":36,
			"componentType":5126,
			"count":169,
			"max":[
				0.9960818290710449,
				0.14077237248420715,
				1
			],
			"min":[
				-1.1061925888061523,
				-0.08340796828269958,
				-1
			],
			"type":"VEC3"
		},
		{
			"bufferView":37,
			"componentType":5126,
			"count":169,
			"type":"VEC3"
		},
		{
			"bufferView":38,
			"componentType":5126,
			"count":169,
			"type":"VEC2"
		},
		{
			"bufferView":39,
			"componentType":5123,
			"count":360,
			"type":"SCALAR"
		},
		{
			"bufferView":40,
			"componentType":5126,
			"count":14518,
			"max":[
				5.818563938140869,
				6.985897064208984,
				0.24733999371528625
			],
			"min":[
				-8.345017433166504,
				-3.6699209213256836,
				-17.667251586914062
			],
			"type":"VEC3"
		},
		{
			"bufferView":41,
			"componentType":5126,
			"count":14518,
			"type":"VEC3"
		},
		{
			"bufferView":42,
			"componentType":5126,
			"count":14518,
			"type":"VEC2"
		},
		{
			"bufferView":43,
			"componentType":5123,
			"count":14520,
			"type":"SCALAR"
		}
	],
	"bufferViews":[
		{
			"buffer":0,
			"byteLength":88632,
			"byteOffset":0,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":88632,
			"byteOffset":88632,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":59088,
			"byteOffset":177264,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":36846,
			"byteOffset":236352,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":9120,
			"byteOffset":273200,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":9120,
			"byteOffset":282320,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":6080,
			"byteOffset":291440,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":6402,
			"byteOffset":297520,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":936,
			"byteOffset":303924,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":936,
			"byteOffset":304860,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":624,
			"byteOffset":305796,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":240,
			"byteOffset":306420,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":2880,
			"byteOffset":306660,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2880,
			"byteOffset":309540,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1920,
			"byteOffset":312420,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":720,
			"byteOffset":314340,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":5496,
			"byteOffset":315060,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":5496,
			"byteOffset":320556,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":3664,
			"byteOffset":326052,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1368,
			"byteOffset":329716,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":23088,
			"byteOffset":331084,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":23088,
			"byteOffset":354172,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":15392,
			"byteOffset":377260,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":10620,
			"byteOffset":392652,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":2412,
			"byteOffset":403272,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2412,
			"byteOffset":405684,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1608,
			"byteOffset":408096,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1764,
			"byteOffset":409704,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":411468,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":411756,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":192,
			"byteOffset":412044,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":72,
			"byteOffset":412236,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":1968,
			"byteOffset":412308,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1968,
			"byteOffset":414276,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1312,
			"byteOffset":416244,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":744,
			"byteOffset":417556,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":2028,
			"byteOffset":418300,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2028,
			"byteOffset":420328,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1352,
			"byteOffset":422356,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":720,
			"byteOffset":423708,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":174216,
			"byteOffset":424428,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":174216,
			"byteOffset":598644,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":116144,
			"byteOffset":772860,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":29040,
			"byteOffset":889004,
			"target":34963
		}
	],
	"buffers":[
		{
			"byteLength":918044,
			"uri":"map.bin"
		}
	]
}
